import * as React from 'react'

import type { Collection } from 'modules/core/lib/mobx-rest'

import type { TeamsShiftLocation } from 'modules/teams/store/collections/teamsShiftLocation'
import type TeamShiftLocationModel from 'modules/teams/store/models/TeamShiftLocationAnalytics'

const Context = React.createContext<TeamsShiftLocation | null | undefined>(null)

export const TeamsShiftLocationProvider = ({
  collection,
  children,
}: {
  collection: Collection<TeamShiftLocationModel>
  children: React.ReactNode
}) => <Context.Provider value={collection as TeamsShiftLocation}>{children}</Context.Provider>

export const useTeamsShiftLocations = (): TeamsShiftLocation => {
  const teamsShiftLocations = React.useContext(Context)

  if (!teamsShiftLocations) {
    throw new Error('useTeamsShiftLocations must be used within a TeamsShiftLocationProvider')
  }

  return teamsShiftLocations
}
